<div class="input-group spinner input-no-arrows">
    <input type="number"
           [ngModel]="value"
           [step]="step"
           [min]="min"
           [required] = "required"
           (ngModelChange)="change($event)"
           class="form-control">
    <div class="input-group-addon">
        <a class="spin-up" data-spin="up" (click) = "stepUp()">
            <i class="fa fa-caret-up"></i>
        </a>
        <a class="spin-down" data-spin="down" (click) = "stepDown()">
            <i class="fa fa-caret-down"></i>
        </a>
    </div>
</div>